import { namespaceConfigurationUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { CrossNameSpaceOrganziation } from "@src/types/namespace-configuration";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "@src/cloud-connect/api/util/build-axios-authentication-headers";

export const getOrganizationById = async (
  namespace: string,
  organizationId: string,
): Promise<CrossNameSpaceOrganziation> => {
  const url = namespaceConfigurationUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.get<CrossNameSpaceOrganziation>(
      `${url}/api/v1/ns/${namespace}/organizations/${organizationId}`,
      { headers },
    );

    return response.data;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);
      throw new Error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to fetch organization. Please try again later.",
      );
    }

    throw new Error(
      "An unexpected error occurred while fetching organization.",
    );
  }
};
